<template>
  <!-- [sc-46314] Cosa si fa in questa pagina e da dove si comincia. Montato
       una volta in App.vue e non nelle otto viste: aggiungere una pagina
       domani e' una riga di registro.

       [revisione 48641] Non e' piu' una striscia. Era larga quanto la pagina,
       tinta del marchio e alta una riga, cioe' identica alla striscia della
       prova che le sta sopra: due avvisi diversi che si leggono come uno solo.
       Adesso e' una scheda staccata, su fondo bianco, con la sua barra a
       sinistra.

       [revisione 48648] Il testo esce intero, senza andare a capo a ogni
       punto: qui sono una o due frasi, e spezzarle lasciava buchi in mezzo
       alla scheda. Titolo e testo partono dallo stesso bordo, subito dopo la
       lampadina. -->
  <div v-if="pannello" class="onb-hint" role="note">
    <i class="fa-solid fa-lightbulb onb-hint__icona" aria-hidden="true"></i>
    <div class="onb-hint__testo">
      <strong class="onb-hint__titolo">{{ pannello.titolo }}</strong>
      <span class="onb-hint__frase">{{ pannello.testo }}</span>
    </div>
    <button
      type="button"
      class="onb-hint__chiudi"
      title="Ho capito, non mostrarlo più"
      aria-label="Ho capito, non mostrarlo più"
      @click="chiudi"
    >
      <i class="fa-solid fa-xmark" aria-hidden="true"></i>
    </button>
  </div>
</template>

<script>
import { pannelloPerRotta } from "@/utilities/onboarding";

export default {
  name: "OnboardingHint",
  computed: {
    pannello() {
      const user = this.$store.state.currentUser;
      if (!user) return null;
      return pannelloPerRotta({
        stato: this.$store.getters["onboarding/stato"],
        user,
        routeName: this.$route.name,
        configured: Boolean(
          this.$store.getters["company/branding"]?.configured
        ),
        readOnly: Boolean(this.$store.getters["company/readOnly"]),
      });
    },
  },
  methods: {
    chiudi() {
      if (!this.pannello) return;
      this.$store.dispatch("segnaPassoTutorial", this.pannello.chiave);
    },
  },
};
</script>

<style scoped>
/* [revisione 48641] Una scheda, non una striscia: la striscia della prova sta
   appena sopra ed era uguale a questa in fondo, corpo e larghezza. Qui il
   fondo e' quello della pagina, i lati non arrivano ai bordi e la barra a
   sinistra dice che e' un'altra voce.

   [revisione 48648] La scheda si stringe sul testo (`fit-content`) invece di
   prendersi tutta la riga: prima restava mezza scheda vuota ai due lati del
   testo centrato. Il tetto resta, per i pannellini lunghi e per gli schermi
   stretti. */
.onb-hint {
  display: flex;
  align-items: center;
  gap: 14px;
  position: relative;
  width: fit-content;
  max-width: min(1100px, calc(100% - 32px));
  margin: 16px auto 0;
  /* A destra ci sta la «x», che e' fuori dal flusso: senza quello spazio il
     testo lungo ci finisce sotto. */
  padding: 14px 44px 14px 18px;
  background: var(--page-bg, #fff);
  /* [sc-48951] Il contorno non è più grigio: era lo stesso grigio dei fili
     delle tabelle, e due grigi quasi uguali sembrano un errore di stampa.
     Prende il colore dell'azienda, appena accennato — è un avviso, non una
     cornice. Il **fondo** resta quello della pagina: tingere anche quello
     l'aveva fatto confondere con la striscia della prova (revisione 48641). */
  border: 0.5px solid rgba(var(--brand-rgb, 15, 23, 42), 0.22);
  border-left: 5px solid var(--brand-on-light, var(--brand));
  border-radius: 10px;
  box-shadow: 0 2px 10px rgba(15, 23, 42, 0.06);
  font-size: 14px;
  line-height: 1.5;
  text-align: left;
}

/* La lampadina dentro il suo cerchio: e' il segno che si vede da lontano, ed
   e' l'unica cosa che tinge del marchio. */
.onb-hint__icona {
  flex: none;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 38px;
  height: 38px;
  border-radius: 50%;
  background: rgba(var(--brand-rgb, 15, 23, 42), 0.1);
  color: var(--brand-on-light, var(--brand));
  font-size: 1.05rem;
}

.onb-hint__testo {
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  gap: 2px;
  min-width: 0;
}

.onb-hint__titolo {
  font-size: 15px;
}

.onb-hint__chiudi {
  position: absolute;
  right: 10px;
  top: 10px;
  border: 0;
  background: none;
  padding: 2px 6px;
  cursor: pointer;
  color: #64748b;
  opacity: 0.7;
}

.onb-hint__chiudi:hover {
  opacity: 1;
}
</style>
